var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'c-list-shop__info--like',
        { active: _vm.isActive },
    ],on:{"click":_vm.toggleFavorite}},[_c('img',{attrs:{"src":"/assets/images/icon/icon-heart-white.svg","width":"12","height":"12","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }